import React, { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { KTSVG } from "../../../_metronic/helpers";
import { TimeOffPoliciesInitialsForAdd, TimeOffPoliciesInitialsForUpdate } from "./interfaces/TimeOffPoliciesClass";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { addTimeOffPolicyAsync, updateTimeOffPolicyAsync, resetSelectedRecordObjectInState } from "./TimeOffPoliciesSlice";
import Select, { StylesConfig } from 'react-select';
import fetchAPI from "../../../common/fetchAPI";
import DatePicker from "react-datepicker";
import { useNavigate } from 'react-router-dom';
import { dropDownSelectionStyles, dateFormatByAccountCulture, getValueFromResource, parseLocalizedNumber, formatNumberCustomoriginalapiv2, determineCommaSeprater } from '../../../common/timeLiveFunction';

import * as yup from 'yup';
import { Formik, useFormik } from 'formik';
import { ShowToast } from '../../../common/Toastr';
import { right } from "@popperjs/core";
import CanvasLoader from "../../../common/CanvasLoader";
import moment from "moment";



export const TimeOffPoliciesForm = (props: any) => {

    const { t, IsEdit, IsDelete } = props;
    const defaultFocusRef = useRef<HTMLInputElement>(null);
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(TimeOffPoliciesInitialsForAdd)
    const [selectedOptionDropDown, setSelectedOptionDropDown] = useState([]);
    const { maxMenuHeight, CurrentCultureDateFormat, cultureInfoName, dateInsertionFormat,isShowTimeOffPoliciesInDays, calendarStartDay , decimalPlaces} = useAppSelector(state => state.globalState);
    const [selectedOptionSystemResetToZeroType, setselectedOptionSystemResetToZeroType] = useState([]);
    const [SystemEarnPeriodsArray, SetSystemEarnPeriodsArray] = useState<any | ''>([]);
    const [SystemResetToZeroTypeArray, SetSystemResetToZeroTypeArray] = useState<any | ''>([]);
    const { selectedRecord, isLoading } = useAppSelector((state) => state.timeOffPolicy);
    const dispatch = useAppDispatch();
    //const IsShowTimeOffPoliciesInDays: boolean = false; //LocaleUtilitiesBLL.IsShowTimeOffPoliciesInDays
    const CarryForwardExpiryDate: string = 'No'; //System.Configuration.ConfigurationManager.AppSettings("CarryForwardExpiryDate")
    const TIMEOFF_ADDITIONAL_HOURS: string = 'No'; //System.Configuration.ConfigurationManager.AppSettings("TIMEOFF_ADDITIONAL_HOURS")
    const navigate = useNavigate();
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    const [isCanvasLoader, setIsCanvasLoader] = useState(true);

    const formik = useFormik({
        initialValues: currentFieldsData, // Pass your initialValues object
        enableReinitialize: true,
        validationSchema: yup.object().shape({
            AccountTimeOffPolicy: yup
                .string()
                .label('AccountTimeOffPolicy')
                .trim()
                .required(t('Time Off Policy is required')),
        }),
        onSubmit: (values, action) => {
            handleSubmit(values);
            action.resetForm();
        },
    });

    const handleSelectAllChange = (e: any) => {
        const { values } = formik;
        const newData = values.detail.map((item: any) => ({
            ...item,
            IsEnabled: e.target.checked === true ? true : false,
        }));

        setCurrentFieldsData({
            ...values,
            detail: newData,
        });

    };

    const allChecked = formik.values.detail.every((item: any) => item.IsEnabled);

    const getSystemEarnPeriodsAsync = async () => {
        setIsCanvasLoader(true);
        const response = await fetchAPI("api/V2/TimeOffPolicies/GetSystemEarnPeriods", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json1 = await response.json();
        const json = json1.Data;

        json.map((item: any) => {
            item.value = item.SystemEarnPeriodId;
            item.label = item.SystemEarnPeriod;
            delete item.SystemEarnPeriodId;
            delete item.SystemEarnPeriod;
        });
        const defaultOption = { value: "0", label: "Never" };
        const arrayWithDefault = [defaultOption, ...json];

        SetSystemEarnPeriodsArray(arrayWithDefault);
        // setIsCanvasLoader(false);
    }

    useEffect(() => {
        getSystemEarnPeriodsAsync();
    }, [])

    const handleSystemEarnPeriodChange = (selectedOption: any, index: any) => {
        const newSelectedOptions: any = [...selectedOptionDropDown];
        newSelectedOptions[index] = selectedOption;
        setSelectedOptionDropDown(newSelectedOptions);

        const { value, label } = selectedOption;
        const newData = formik.values.detail.map((item: any, i: any) => {
            if (i === index) {
                return { ...formik.values.detail[index], 'SystemEarnPeriodId': value };
            }
            return item;
        });
        setCurrentFieldsData((currentFieldsData: any) => ({
            ...formik.values,
            detail: newData,
        }));
    };

    const getSystemResetToZeroType = async () => {
        const response = await fetchAPI("api/V2/TimeOffPolicies/GetSystemResetToZeroType", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json1 = await response.json();
        const json = json1.Data;
        json.map((item: any) => {
            item.value = item.SystemResetToZeroTypeId;
            item.label = item.SystemResetToZeroType;
            delete item.SystemResetToZeroTypeId;
            delete item.SystemResetToZeroType;
        });

        const defaultOption = { value: "0", label: "Never" };
        const arrayWithDefault = [defaultOption, ...json];

        SetSystemResetToZeroTypeArray(arrayWithDefault);
    }

    useEffect(() => {
        getSystemResetToZeroType();
    }, [])

    const handleSystemResetToZeroTypeChange = (selectedOption: any, index: any) => {
        const newSelectedOptions: any = [...selectedOptionSystemResetToZeroType];
        newSelectedOptions[index] = selectedOption;
        setselectedOptionSystemResetToZeroType(newSelectedOptions);

        const { value, label } = selectedOption;
        const newData = formik.values.detail.map((item: any, i: any) => {
            if (i === index) {
                return { ...formik.values.detail[index], 'SystemResetToZeroTypeId': value };
            }
            return item;
        });
        setCurrentFieldsData((currentFieldsData: any) => ({
            ...formik.values,
            detail: newData,
        }));
    };

    useEffect(() => {

        let stateItem: any = {}
        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;
            Object.keys(TimeOffPoliciesInitialsForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
            })
            setCurrentFieldsData(stateItem);
            stateItem.IsDisabled = stateItem.IsDisabled === 'No' ? false : true;
            if (stateItem.detail !== undefined) {
                stateItem.detail = stateItem.detail.map((item: any) => {
                    const newItem = { ...item };
                    newItem.IsEnabled = newItem.IsEnabled === 'No' ? false : true;
                    newItem.IsTimeOffRequestRequired = false;
                    newItem.InitialSetToHours = formatNumberCustomoriginalapiv2(
                        cultureInfoName.toString(),
                        item.InitialSetToHours,
                        2
                    );

                    newItem.InitialSetHours = formatNumberCustomoriginalapiv2(
                        cultureInfoName.toString(),
                        item.InitialSetHours,
                        2
                    );

                    newItem.ResetToHours = formatNumberCustomoriginalapiv2(
                        cultureInfoName.toString(),
                        item.ResetToHours,
                        2
                    );

                    newItem.EarnHours = formatNumberCustomoriginalapiv2(
                        cultureInfoName.toString(),
                        item.EarnHours,
                        2
                    );

                    newItem.MaximumAvailable = formatNumberCustomoriginalapiv2(
                        cultureInfoName.toString(),
                        item.MaximumAvailable,
                        2
                    );

                    newItem.AdditionalHours = formatNumberCustomoriginalapiv2(
                        cultureInfoName.toString(),
                        item.AdditionalHours,
                        2
                    );
                    return newItem;
                });

                let newSelectedOptions: any = [...selectedOptionSystemResetToZeroType];
                stateItem.detail.map((pitem: any, index: any) => {
                    const nselectedoption = SystemResetToZeroTypeArray.find((SystemResetToZeroType: any) => SystemResetToZeroType.value == pitem.SystemResetToZeroTypeId);
                    if (nselectedoption !== undefined) {
                        newSelectedOptions[index] = nselectedoption
                        setselectedOptionSystemResetToZeroType(newSelectedOptions);
                    }
                    else {
                        newSelectedOptions[index] = { value: "0", label: "Never" };
                        setselectedOptionSystemResetToZeroType(newSelectedOptions);
                    }
                });

                let newSelectedOptionsPeriods: any = [...selectedOptionDropDown];
                stateItem.detail.map((pitem: any, index: any) => {
                    const nselectedoptionPeriods = SystemEarnPeriodsArray.find((SystemEarnPeriods: any) => SystemEarnPeriods.value == pitem.SystemEarnPeriodId);
                    if (nselectedoptionPeriods !== undefined) {
                        newSelectedOptionsPeriods[index] = nselectedoptionPeriods
                        setSelectedOptionDropDown(newSelectedOptionsPeriods);
                    }
                    else {
                        newSelectedOptionsPeriods[index] = { value: "0", label: "Never" };
                        setSelectedOptionDropDown(newSelectedOptionsPeriods);
                    }
                });
                setIsCanvasLoader(false);
            }

        }
        else {
            setCurrentFieldsData(TimeOffPoliciesInitialsForAdd);
        } if (defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        }

    }, [selectedRecord])

    const handleTextChange = (e: any) => {
        setCurrentFieldsData({ ...currentFieldsData, [e.target.id]: (e.target.type === 'checkbox' ? e.target.checked : e.target.value) })
    }
    const emptyGuid = '00000000-0000-0000-0000-000000000000';
    const isGuid = (stringToTest: any) => {
        if (stringToTest[0] === "{") {
            stringToTest = stringToTest.substring(1, stringToTest.length - 1);
        }
        var regexGuid = /^(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/gi;
        var x = regexGuid.test(stringToTest);
        return x;
    };
    const isValidCultureNumber = (value: string, isComma: boolean) => {
    if (!value) return true;
    if (isComma && value.includes('.')) return false;
    if (!isComma && value.includes(',')) return false;
  
    const regex = isComma
        ? /^\d*(,\d*)?$/
        : /^\d*(\.\d*)?$/;

    return regex.test(value);
};
    const handleNameChange = (index: any, e: any) => {
       const { value, id } = e.target;
        const isComma = determineCommaSeprater(cultureInfoName.toString());
        if (!isValidCultureNumber(value, isComma)) {
            return; 
        }
        const newData = formik.values.detail.map((item: any, i: any) => {
            if (i === index) {
                return { ...formik.values.detail[index], [e.target.id]: e.target.value };
            }
            return item;
        });
        setCurrentFieldsData((currentFieldsData: any) => ({
            ...formik.values,
            detail: newData,
        }));
    };

    const handleClose = (e: any) => {
        navigate('/timeOffPolicies');
    };
    const handleSubmit = (e: any) => {
        const payload = {
            ...formik.values,
            detail: formik.values.detail.map((item: any) => ({
                ...item,
                InitialSetToHours: parseLocalizedNumber(item.InitialSetToHours),
                ResetToHours: parseLocalizedNumber(item.ResetToHours),
                EarnHours: parseLocalizedNumber(item.EarnHours),
                MaximumAvailable: parseLocalizedNumber(item.MaximumAvailable),
                AdditionalHours: parseLocalizedNumber(item.AdditionalHours),
            }))
        };
        if (emptyGuid !== formik.values.AccountTimeOffPolicyId && isGuid(formik.values.AccountTimeOffPolicyId)) {
            dispatch(updateTimeOffPolicyAsync(payload))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "200" ?
                        ShowToast("Time Off Policy Update Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                    //  modelRef.current.click();
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }
        else {
            dispatch(addTimeOffPolicyAsync(payload))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "201" ?
                        ShowToast("Time Off Policy Added Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
    }
    const onEffectiveDateChange = (index: any, date: any) => {
        const newData = formik.values.detail.map((item: any, i: any) => {
            if (i === index) {
               // return { ...formik.values.detail[index], 'EffectiveDate': date };
               //return { ...formik.values.detail[index], 'EffectiveDate': dateFormatByAccountCulture(new Date(date).toISOString(), cultureInfoName.toString()) };
            // return { ...formik.values.detail[index], 'EffectiveDate': new Date(date).toISOString() };
            return { ...formik.values.detail[index], 'EffectiveDate': moment(date).format('YYYY-MM-DD') };
            }
            return item;
        });
        setCurrentFieldsData((currentFieldsData: any) => ({
            ...formik.values,
            detail: newData
        }));

    };
    const onCarryForwardExpiryDateChange = (index: any, date: any) => {
        const newData = formik.values.detail.map((item: any, i: any) => {
            if (i === index) {
                // return { ...formik.values.detail[index], 'CarryForwardExpiryDate': date };
                return { ...formik.values.detail[index], 'CarryForwardExpiryDate': new Date(date).toISOString() };
            }
            return item;
        });
        setCurrentFieldsData((currentFieldsData: any) => ({
            ...formik.values,
            detail: newData,
        }));

    };
    const handleCheckboxChange = (e: any, index: any) => {
        const newData = formik.values.detail.map((item: any, i: any) => {
            if (i === index) {
                return { ...formik.values.detail[index], 'IsEnabled': e.target.checked };
            }
            return item;
        });

        setCurrentFieldsData((currentFieldsData: any) => ({
            ...formik.values,
            detail: newData,
        }));
    };
    const handleCloseOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState());
    }

    return (
        <>

            <div className='card-body card-pad'>
            <div className='row'>
                        <div className={emptyGuid !== formik.values.AccountTimeOffPolicyId ? "col-md-6 mb-2" : "col-md-12 mb-2"}>
                            <label className="form-label fs-7 fw-normal mb-2">
                                {/* {t('Time Off Policy')} */}
                                {getValueFromResource('Time Off Policy',dispatch, t)}
                                </label>
                            <input type="text"
                                className="form-control fs-7 fw-normal"
                                id='AccountTimeOffPolicy'
                                value={formik.values.AccountTimeOffPolicy}
                                onChange={formik.handleChange('AccountTimeOffPolicy')}
                                ref={defaultFocusRef}
                            // onBlur={() => formik.setFieldTouched('AccountTimeOffPolicy')}

                            />
                            <div >
                                {formik.touched.AccountTimeOffPolicy && formik.errors.AccountTimeOffPolicy &&
                                    <p className='errorMsg'>{formik.errors.AccountTimeOffPolicy as string}</p>
                                }
                            </div>
                        </div>

                        {/* {(emptyGuid !== formik.values.AccountTimeOffPolicyId) ? (
    <div className="col-md-6 mb-2">
        <label className="form-label">{t('Disabled')}</label>
        <div className="form-check form-switch form-check-custom form-check-solid me-10">
            <input
                type="checkbox"
                className="form-check-input h-20px w-30px mt-2"
                checked={formik.values.IsDisabled}
                id="IsDisabled"
                onChange={formik.handleChange('IsDisabled')}
            />
        </div>
    </div>
) : (
    timeOffPolicyList.find(x => x.AccountTimeOffPolicyId === formik.values.AccountLocationId)?.IsDisabled.toString() === "Yes" && (
        <div className="mb-3">
            <label className="fs-7 fw-normal mt-2">{t('Disabled')}</label>
            <div className="form-check form-switch form-check-custom form-check-solid me-10">
                <input
                    className="form-check-input h-20px w-30px mt-2"
                    type="checkbox"
                    checked={formik.values.IsDisabled}
                    id="IsDisabled"
                    onChange={formik.handleChange('IsDisabled')}
                />
            </div>
        </div>
    )
)}   */}
                        {(emptyGuid !== formik.values.AccountTimeOffPolicyId) ? (
                            <div className="col-md-6 mb-2">
                                <label className="form-label">
                                    {/* {t('Disabled')} */}
                                    {getValueFromResource('Disabled',dispatch, t)}
                                    </label>
                                <div className="form-check form-switch form-check-custom text-center form-check-solid me-10">
                                    <input type="checkbox"
                                        className="form-check-input h-20px w-30px mt-2"
                                        checked={formik.values.IsDisabled}
                                        id="IsDisabled"
                                        onChange={formik.handleChange('IsDisabled')}
                                    />
                                </div>
                            </div>
                        ) : null}
                        <hr />
                        <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" style={{ overflow: 'auto' }}>
                            <thead>
                                <tr className="thHeading align-middle">
                                    <th className='w-25px'>
                                        <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                                            <input
                                                className='form-check-input'
                                                type='checkbox'
                                                checked={allChecked}
                                                onChange={handleSelectAllChange}
                                            />
                                        </div>
                                    </th>
                                    <th className='w-5'>
                                        {/* {t('Time Off Type')} */}
                                        {getValueFromResource('Time Off Type',dispatch, t)}

                                        </th>
                                    <th className='w-5 text-center' style={{ width: '150px' }}>
                                        {/* {t('Effective Date')} */}
                                        {getValueFromResource('Effective Date',dispatch, t)}
                                        </th>
                                    {CarryForwardExpiryDate === "Yes" ? (
                                        <th>
                                            {/* {t('CarryForwardExpiryDate')} */}
                                            {getValueFromResource('CarryForwardExpiryDate',dispatch, t)}
                                            </th>
                                    ) : null}
                                    {isShowTimeOffPoliciesInDays ? (
                                        <>
                                            <th className='w-5 text-center' style={{ width: '100px' }}>
                                                {/* {t('Initial Set to Days')} */}
                                                {getValueFromResource('Initial Set to Days',dispatch, t)}
                                                </th>
                                            <th className='w-5' style={{ width: '100px' }}>
                                                {/* {t('Earn Days')} */}
                                                {getValueFromResource('Earn Days',dispatch, t)}
                                                </th>
                                        </>
                                    ) :
                                        <>
                                            <th className='w-5' style={{ width: '100px' }}>
                                                {/* {t('Initial Set to Hours')} */}
                                                {getValueFromResource('Initial Set to Hours',dispatch, t)}
                                                </th>
                                            <th className='w-5 text-center' style={{ width: '100px' }}>
                                                {/* {t('Earn Hours')} */}
                                                {getValueFromResource('Earn Hours',dispatch, t)}
                                                </th>
                                        </>
                                    }

                                    <th className='w-5 text-center'>
                                        {/* {t('Earn Period')} */}
                                        {getValueFromResource('Earn Period',dispatch, t)}
                                        </th>
                                    <th className='w-5 text-center'>
                                        {/* {t('Reset at')} */}
                                        {getValueFromResource('Reset at',dispatch, t)}
                                        </th>

                                    {isShowTimeOffPoliciesInDays ? (
                                        <>
                                            <th className='w-5' style={{ width: '100px' }}>
                                                {/* {t('Reset Days')} */}
                                                {getValueFromResource('Reset Days',dispatch, t)}
                                                </th>
                                            <th className='w-5' style={{ width: '100px' }}>
                                                {/* {t('Maximum Available Days')} */}
                                                {getValueFromResource('Maximum Available Days',dispatch, t)}
                                                </th>
                                        </>
                                    ) :
                                        <>
                                            <th className='w-2' style={{ width: '100px' }}>
                                                {/* {t('Reset Hours')} */}
                                                {getValueFromResource('Reset Hours',dispatch, t)}
                                                </th>
                                            <th className='w-2' style={{ width: '100px' }}>
                                                {/* {t('Maximum Available Hours')} */}
                                                {getValueFromResource('Maximum Available Hours',dispatch, t)}
                                                </th>
                                        </>
                                    }

                                    {TIMEOFF_ADDITIONAL_HOURS === "Yes" ? (
                                        <th className='w-5'>
                                            {/* {t('Additional Hours')} */}
                                            {getValueFromResource('Additional Hours',dispatch, t)}
                                            </th>
                                    ) : null}
                                </tr>
                            </thead>
                            <tbody>

                                {Object.values(formik.values.detail).map((timeOffPolicyDetails: any, index: any) =>{
                                    return(

                                    <tr key={index}>
                                        <td>
                                            <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    // checked={timeOffPolicyDetails.IsEnabled}
                                                    checked={timeOffPolicyDetails.IsEnabled}
                                                    //onChange={e => handleCheckboxChange(e, index)}
                                                    onChange={e => handleCheckboxChange(e, index)}
                                                    style={{ textAlign: 'right' }}
                                                />
                                            </div>
                                        </td>
                                        <td>{timeOffPolicyDetails.AccountTimeOffType}</td>
                                        <td>
                                            <DatePicker
                                                //selected={timeOffPolicyDetails.EffectiveDate == null ? new Date() : new Date(timeOffPolicyDetails.EffectiveDate)}
                                                // selected={timeOffPolicyDetails.EffectiveDate == null ? new Date() : dateFormatByAccountCulture(timeOffPolicyDetails.AccountTimeOffPolicyDetailId == "00000000-0000-0000-0000-000000000000" ? timeOffPolicyDetails.EffectiveDate.toISOString() :  timeOffPolicyDetails.EffectiveDate, cultureInfoName.toString())}
                                                selected={timeOffPolicyDetails.EffectiveDate == null ? new Date() : dateFormatByAccountCulture(timeOffPolicyDetails.EffectiveDate, cultureInfoName.toString())}
                                                onChange={e => onEffectiveDateChange(index, e)}
                                                calendarStartDay={calendarStartDay}
                                                id="EffectiveDate"
                                                dateFormat={CurrentCultureDateFormat.toString()}
                                                className="form-control fs-7 fw-normal">
                                            </DatePicker>
                                        </td>

                                        {CarryForwardExpiryDate === "Yes" ? (

                                            <td>
                                                <DatePicker
                                                    // selected={timeOffPolicyDetails.CarryForwardExpiryDate == null ? new Date() : new Date(timeOffPolicyDetails.CarryForwardExpiryDate)}
                                                    // selected={timeOffPolicyDetails.CarryForwardExpiryDate == null ? new Date() : dateFormatByAccountCulture(timeOffPolicyDetails.AccountTimeOffPolicyDetailId == "00000000-0000-0000-0000-000000000000" ? timeOffPolicyDetails.CarryForwardExpiryDate.toISOString() : timeOffPolicyDetails.CarryForwardExpiryDate, cultureInfoName.toString())}
                                                    selected={timeOffPolicyDetails.CarryForwardExpiryDate == null ? new Date() : dateFormatByAccountCulture(timeOffPolicyDetails.CarryForwardExpiryDate, cultureInfoName.toString())}
                                                    onChange={e => onCarryForwardExpiryDateChange(index, e)}
                                                    id="CarryForwardExpiryDate"
                                                    dateFormat={CurrentCultureDateFormat.toString()}
                                                    className="form-control fs-7 fw-normal" >
                                                </DatePicker>
                                            </td>
                                        ) : null}
                                        <td>
                                            <input type="text"
                                                className="form-control fs-7 fw-normal"
                                                id='InitialSetToHours'
                                                value={timeOffPolicyDetails.InitialSetToHours == null ? 0 : timeOffPolicyDetails.InitialSetToHours}
                                                onChange={e => handleNameChange(index, e)}
                                                style={{ textAlign: 'right' }}
                                            />
                                        </td>
                                        <td>
                                            <input type="text" className="form-control fs-7 fw-normal" id='EarnHours'
                                                value={timeOffPolicyDetails.EarnHours == null ? 0 : timeOffPolicyDetails.EarnHours}
                                                onChange={e => handleNameChange(index, e)}
                                                style={{ textAlign: 'right' }}
                                            />
                                        </td>
                                        <td>
                                            <Select
                                                key={index}
                                                value={selectedOptionDropDown[index]}
                                                onChange={(selectedOption) => handleSystemEarnPeriodChange(selectedOption, index)}
                                                options={SystemEarnPeriodsArray}
                                                placeholder="Select an option"
                                                styles={dropDownSelectionStyles}
                                                maxMenuHeight={maxMenuHeight}
                                                isSearchable={true}
                                                className="basic-single"
                                                classNamePrefix="select"
                                                id="SystemEarnPeriodId"
                                            />
                                        </td>
                                        <td>
                                            <Select
                                                key={index}
                                                value={selectedOptionSystemResetToZeroType[index]}
                                                onChange={(selectedOption) => handleSystemResetToZeroTypeChange(selectedOption, index)}
                                                options={SystemResetToZeroTypeArray}
                                                placeholder="Select an option"
                                                styles={dropDownSelectionStyles}
                                                maxMenuHeight={maxMenuHeight}
                                                isSearchable={true}
                                                className="basic-single"
                                                classNamePrefix="select"
                                                id="SystemResetToZeroTypeId"
                                            />
                                        </td>
                                        <td>
                                            <input type="text" className="form-control fs-7 fw-normal" id='ResetToHours'
                                                value={timeOffPolicyDetails.ResetToHours == null ? 0 : timeOffPolicyDetails.ResetToHours}
                                                onChange={e => handleNameChange(index, e)}
                                                style={{ textAlign: 'right' }}
                                            />
                                        </td>
                                        <td>
                                            <input type="text" className="form-control fs-7 fw-normal" id='MaximumAvailable'
                                                value={timeOffPolicyDetails.MaximumAvailable == null ? 0 : timeOffPolicyDetails.MaximumAvailable}
                                                onChange={e => handleNameChange(index, e)}
                                                style={{ textAlign: 'right' }}
                                            />
                                        </td>
                                        {TIMEOFF_ADDITIONAL_HOURS === "Yes" ? (
                                            <td>
                                                <input type="text" className="form-control fs-7 fw-normal" id='AdditionalHours'
                                                    value={timeOffPolicyDetails.AdditionalHours == null ? 0 : timeOffPolicyDetails.AdditionalHours}
                                                    onChange={e => handleNameChange(index, e)}
                                                    style={{ textAlign: 'right' }}

                                                />
                                            </td>
                                        ) : null}
                                    </tr>
                                )})}

                            </tbody>
                        </table>

                    </div>
                {isCanvasLoader ? <CanvasLoader /> : <>
                    {/* {isLoading ?
                                <div className="col-md-12">
                                    <span className='indicator-progress' style={{ display: 'block' }}>
                                        <span className='spinner-border spinner-border-md ms-2'></span>
                                    </span>
                                </div>
                                : <> */}
                  
                    {/* </>
                            } */}
                </>}

                {Object.keys(formik.errors).length > 0 && (
                    <div className="mt-3 alert alert-danger">
                        <strong>
                            {/* {t('Error Summary')}: */}
                            {getValueFromResource('Error Summary',dispatch, t)}:
                            </strong>
                        <ul>
                            {Object.keys(formik.errors).map((fieldName, index) => (
                                <li key={index}>{formik.errors[fieldName] as string}</li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
            <div className='card-footer pt-4 '>
                <div className='d-flex flex-stack float-end'>
                    <div className='d-flex align-items-center me-2'>
                        <button
                            ref={closeButtonRef}
                            type="button"
                            className="btn btn-secondary btn-bs-btn-font-weight me-2 btn-sm fs-7"
                            id="kt_OffCanvas"
                            onClick={handleCloseOnClickEvent}
                        >
                            {/* {t('Cancel')} */}
                            {getValueFromResource('Cancel',dispatch, t)}

                        </button>

                        <button type="button" className="btn btn-sm btn-primary" onClick={() => formik.handleSubmit()} disabled={!formik.isValid}>

                            {/* {t('Save')} */}
                            {getValueFromResource('Save',dispatch, t)}
                        </button>
                    </div>
                </div>
            </div>
            {/* <}
                    {/* </Fragment>
                )}
            </Formik> */}
        </>
    )
}
const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '36px', height: '36px', padding: '-1px' }),
}



